import { DETAILS_TEXT_LIMIT } from './AffordableDetails';

export const CHARACTER_LIMIT_ERROR_MESSAGE = 'Character Limit Exceeded';

export const getValidationErrorMessages = (details, incomeEligibility) => {
  const { hasIncomeEligibilityError, updatedIncomeEligibility } =
    incomeEligibility.reduce(
      (updatedEligibleQualifications, eligibleQualification) => {
        const { occupants, maximum_income: maxIncome } = eligibleQualification;
        if (!occupants || !maxIncome) {
          updatedEligibleQualifications.hasIncomeEligibilityError = true;
          eligibleQualification.errorMessages = {
            ...(!maxIncome && { maxIncome: 'required' }),
            ...(!occupants && { occupants: 'required' }),
          };
        }
        updatedEligibleQualifications.updatedIncomeEligibility = [
          ...updatedEligibleQualifications.updatedIncomeEligibility,
          eligibleQualification,
        ];
        return updatedEligibleQualifications;
      },
      { hasIncomeEligibilityError: false, updatedIncomeEligibility: [] }
    );

  const detailsErrormessage =
    details.length > DETAILS_TEXT_LIMIT ? CHARACTER_LIMIT_ERROR_MESSAGE : '';

  if (detailsErrormessage || hasIncomeEligibilityError) {
    return {
      ...(detailsErrormessage && { details: detailsErrormessage }),
      ...(hasIncomeEligibilityError && {
        incomeEligibility: updatedIncomeEligibility,
      }),
    };
  }
};

export const getHasValidationErrors = (
  detailsErrorMessage,
  incomeEligibility
) =>
  Boolean(detailsErrorMessage) ||
  incomeEligibility.some((eligibleQualification) => {
    const { errorMessages = {} } = eligibleQualification;
    return Boolean(errorMessages.maxIncome) || Boolean(errorMessages.occupants);
  });

export const getHasAffordableChanged = ({
  affordableDetails,
  affordableIncomeEligibility,
  details,
  incomeEligibility,
}) => {
  const hasAffordableDataChanged =
    affordableDetails !== details ||
    affordableIncomeEligibility.length !== incomeEligibility.length;

  if (hasAffordableDataChanged) {
    return true;
  }

  const incomeEligibilityMap = incomeEligibility.reduce(
    (eligibilityMap, eligibleQualification) => {
      const { occupants, maximum_income } = eligibleQualification;
      eligibilityMap[occupants] = maximum_income;

      return eligibilityMap;
    },
    {}
  );

  return affordableIncomeEligibility.some((eligibleQualification) => {
    const { occupants, maximum_income } = eligibleQualification;
    return (
      !incomeEligibilityMap[occupants] ||
      incomeEligibilityMap[occupants] !== maximum_income
    );
  });
};
